"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _commonHelper = require("../../helpers/commonHelper");
var _Spinner = _interopRequireDefault(require("../../Spinner"));
var _red = _interopRequireDefault(require("../../tokens/color/red"));
var _grey = _interopRequireDefault(require("../../tokens/color/grey"));
var _black = _interopRequireDefault(require("../../tokens/color/black"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var OTPbox = function OTPbox(props) {
  var length = props.length,
    fnInputFill = props.fnInputFill,
    onChange = props.onChange,
    alignInput = props.alignInput,
    inputType = props.inputType,
    loading = props.loading;
  var _useState = (0, _react.useState)(0),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    isFocused = _useState2[0],
    setFocused = _useState2[1];
  var _useState3 = (0, _react.useState)({}),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    inputValue = _useState4[0],
    setValue = _useState4[1];
  var handleOnchange = function handleOnchange(e, inputIndex) {
    onChange(e);
    var inputCurrentValue = e.target.value || "";
    if (!inputCurrentValue || !isAlphaNum(inputCurrentValue)) {
      return;
    }
    var splitText = inputCurrentValue.split("");
    var valueArr = splitText.splice(0, length - inputIndex);
    var updatedInputValue = valueArr.reduce(function (result, key, idx) {
      return _objectSpread(_objectSpread({}, result), {}, (0, _defineProperty2["default"])({}, inputIndex + idx, key));
    }, {});
    var newValue = _objectSpread(_objectSpread({}, inputValue), updatedInputValue);
    var lastIndex = inputIndex + valueArr.length;
    if (lastIndex >= length) {
      lastIndex = length - 1;
    }
    setValue(newValue);
    setFocused(lastIndex);
    var otpValueLength = Object.values(newValue).length;
    if (otpValueLength === length) {
      var otpValue = Object.values(newValue).join("");
      fnInputFill(otpValue);
    }
  };
  var isAlphaNum = function isAlphaNum(str) {
    return /^[a-zA-Z0-9]+$/.test(str);
  };
  var handleInputKeyDown = function handleInputKeyDown(index) {
    return function (e) {
      onChange(e);
      switch (e.keyCode) {
        case 8:
          // backspace
          setFocused(index - 1);
          var newValue = _objectSpread({}, inputValue);
          delete newValue[index];
          setValue(newValue);
          break;
        case 39:
          //right arrows
          setFocused(index + 1);
          break;
        case 37:
          // left arrow
          setFocused(index - 1);
          break;
      }
    };
  };
  return /*#__PURE__*/_react["default"].createElement(Holder, null, /*#__PURE__*/_react["default"].createElement(OTPbox.Wrapper, {
    alignInput: alignInput
  }, /*#__PURE__*/_react["default"].createElement(OTPbox.Container, {
    length: length
  }, getInputs(isFocused, length, /*#__PURE__*/_react["default"].createElement(Input, (0, _extends2["default"])({}, props, {
    inputType: inputType,
    onChange: handleOnchange,
    setFocus: setFocused,
    handleKeyDown: handleInputKeyDown,
    disabled: loading
  })), inputValue))), loading && /*#__PURE__*/_react["default"].createElement(_Spinner["default"], {
    color: _red["default"].z500
  }));
};
var Holder = /*#__PURE__*/_styledComponents["default"].div.withConfig({
  componentId: "sc-hp56s6-0"
})(["text-align:center;"]);
var Input = function Input(props) {
  var _props$isFocused = props.isFocused,
    isFocused = _props$isFocused === void 0 ? false : _props$isFocused,
    onChange = props.onChange,
    index = props.index,
    setFocus = props.setFocus,
    handleKeyDown = props.handleKeyDown,
    inputType = props.inputType,
    isSecure = props.isSecure;
  var handleFocus = function handleFocus(index) {
    return function () {
      return setFocus(index);
    };
  };
  var handleOnchange = function handleOnchange(index) {
    return function (e) {
      return onChange(e, index);
    };
  };
  var ref = (0, _react.useRef)();
  (0, _react.useEffect)(function () {
    if (ref.current && isFocused) {
      ref.current.focus();
    }
  }, [isFocused]);
  var specialInputProps = {
    pattern: inputType === "number" ? "[0-9]{1}" : "[a-zA-Z0-9]{1}",
    inputMode: inputType === "number" ? "numeric" : "text",
    type: inputType === "number" ? "number" : "text"
  };
  return /*#__PURE__*/_react["default"].createElement(Input.El, (0, _extends2["default"])({}, props, {
    ref: ref,
    onChange: handleOnchange(index),
    maxLength: 2,
    onClick: handleFocus(index),
    onKeyDown: handleKeyDown(index)
  }, specialInputProps, {
    type: isSecure ? "password" : specialInputProps.type
  }));
};
Input.propTypes = {
  isFocused: _propTypes["default"].bool,
  onChange: _propTypes["default"].func.isRequired,
  index: _propTypes["default"].number.isRequired,
  setFocus: _propTypes["default"].func.isRequired,
  onPaste: _propTypes["default"].func.isRequired,
  handleKeyDown: _propTypes["default"].func.isRequired,
  inputType: _propTypes["default"].string,
  isSecure: _propTypes["default"].bool
};
var getInputs = function getInputs(focused, length, component, values) {
  var inputs = [];
  for (var i = 0; i < length; i++) {
    var isFocused = i == focused;
    inputs.push((0, _commonHelper.cloneChildren)(component, {
      index: i,
      isFocused: isFocused,
      value: values[i] || ""
    }));
  }
  return inputs;
};
OTPbox.propTypes = {
  length: _propTypes["default"].number,
  fnInputFill: _propTypes["default"].func.isRequired,
  onChange: _propTypes["default"].func.isRequired,
  alignInput: _propTypes["default"].oneOf(["left", "right", "center"]),
  inputType: _propTypes["default"].oneOf(["text", "number"]),
  loading: _propTypes["default"].bool,
  isSecure: _propTypes["default"].bool
};
OTPbox.defaultProps = {
  length: 1,
  alignInput: "center",
  inputType: "text",
  loading: false,
  isSecure: false
};
Input.El = _styledComponents["default"].input.withConfig({
  componentId: "sc-hp56s6-1"
})(["-webkit-appearance:none;&::-webkit-outer-spin-button{-webkit-appearance:none;margin:0;}&::-webkit-inner-spin-button{-webkit-appearance:none;margin:0;}height:4.8rem;width:5.6rem;border:1px solid #cfcfcf;border-radius:0.8rem;padding:0;text-align:center;font-size:1.6rem;color:", ";@media (max-width:480px){width:4.8rem;padding:0;}:focus{border:1px solid #009999;}"], function (props) {
  return props.disabled ? _grey["default"].z300 : _black["default"];
});
OTPbox.Container = _styledComponents["default"].div.withConfig({
  componentId: "sc-hp56s6-2"
})(["display:flex;justify-content:space-between;width:", ";@media (max-width:480px){width:", ";}"], function (props) {
  return props.length ? "calc((".concat(props.length, " * 5.6rem) + ((").concat(props.length, " - 1) * 1.3rem))") : "auto";
}, function (props) {
  return props.length ? "calc((".concat(props.length, " * 4.8rem) + ((").concat(props.length, " - 1) * 1rem))") : "auto";
});
var alignEnum = function alignEnum(alignProp) {
  switch (alignProp) {
    case "left":
      return "flex-start";
    case "right":
      return "flex-end";
    default:
      return "center";
  }
};
OTPbox.Wrapper = _styledComponents["default"].div.withConfig({
  componentId: "sc-hp56s6-3"
})(["display:flex;justify-content:", ";"], function (_ref) {
  var alignInput = _ref.alignInput;
  return alignEnum(alignInput);
});
var _default = exports["default"] = OTPbox;